import BlockLeftImage from "./BlockLeftImage";
import Accordion from "./Accordion";

import "../css/blockpagos.css";
import BlockRightImage from "./BlockRightImage";

function PosgradoPagos() {
  return (
    <>
      <div className="icon350 descuentos-section" id="descuentos">
        <BlockLeftImage
          src="https://utpl.edu.ec/recursos/img/costos.gif"
          content={
            <>
              <h3>
                Obtén hasta un <b>20% de descuento </b>en tu matrícula{" "}
              </h3>
              <p>
                <p className="yellow">
                  <b>Descuentos:</b>
                </p>
                🟢 <b>10% de descuento</b> al pagar el programa completo o{" "}
                <b>5% de descuento</b> si eliges pagar semestralmente.  (El pago semestral no aplica para programas de especialización).
              </p>
              <p>
                🟢 <b>10% de descuento adicional </b>si eres UTPL Alumni.
              </p>
              <p className="yellow">
                <b>Becas:</b>
              </p>
              <p>
                🟢 <b> 10% de descuento adicional</b> por Beca Convenio.
              </p>
              <a
                className="link-with-arrow"
                target="_blank"
                href="https://becas.utpl.edu.ec/convenio"
              >
                Postula hoy mismo
              </a>
              <p>🟢Beca Discapacidad</p>
              <a
                className="link-with-arrow"
                target="_blank"
                href="https://becas.utpl.edu.ec/discapacidad"
              >
                Consulta los requisitos
              </a>
              <h4>
                <b>💳 ¡Difiere tu matrícula </b> <br></br> sin intereses!
              </h4>
              <p>
                🟢Hasta <b>12 meses</b>
              </p>
              <p>
                🟢Hasta <b>24 meses (aplica en montos mayores a $2 000)</b>
              </p>
              <a
                className="link-with-arrow"
                target="_blank"
                href="https://utpl.edu.ec/documentos/opcionespago.pdf"
              >
                Conoce aquí nuestras opciones de pago
              </a>
              <br></br> <br></br>
              <Accordion
                title="Plan de pagos (pagos semestrales)"
                content={
                  <>
                 
                    <p>
                      <b>
                        Si optas por un plan de pagos, no obtendrás el descuento
                        por forma de pago.
                      </b>
                    </p>
                    <ul>
                      <li>
                        <p>
                          Paga 50% al momento de la matrícula y 50% a 60 días
                          plazo.
                        </p>
                      </li>

                      <li>
                        <p>
                          Paga 40% al momento de la matrícula, 30% hasta el 17
                          de noviembre y 30% hasta el 30 de diciembre de 2025.
                        </p>
                      </li>
                    </ul>
                    <p></p>
                  </>
                }
              ></Accordion>
            </>
          }
        ></BlockLeftImage>
      </div>
    </>
  );
}

export default PosgradoPagos;
